
import moment from 'moment'
import Vue from 'vue'
import { forEach, orderBy, find, replace, isEmpty } from 'lodash'
import xss from 'xss'

const globalMixin = {
  methods: {
    serialize (obj) {
      return '?' + this.removeUndefined(Object.keys(obj).reduce(function (a, k) { a.push(k + '=' + encodeURIComponent(obj[k])); return a }, []).join('&'))
    },
    removeUndefined (data) {
      return replace(data, /=(null|undefined|NaN)/gi, '=')
    },
    // _.escape | .escapeRegExp
    parserEscape (data) {
      return replace(replace(xss(data), /(?:\r\n|\r|\n)/g, '<br>'), /\s/gi, '&nbsp;')
    },
    dtmFormat (dtm, format) {
      /*
        dtm의 값이 다른데 모두 2024/06/25로 출력되는 현상으로 아래 코드는 사용하지 않습니다.

        원인: dtm이 Epoch 이후 시점으로 출력되어 원하는 날짜형식으로 출력이 안됨

        설명
        moment(1706661722000)을 호출하면 이 숫자는 날짜와 시간으로 변환되어 2024/06/25로 포맷팅됩니다.
        따라서 dtmFormat 함수에 이 숫자들을 입력하면 모두 2024/06/25가 출력되는 것입니다.

        예를 들어,
        dtm=1706661722000일 때, 2024/01/31 09:42:02.0로 출력되길 기대하고
        dtm=1709870075000일 때 2024/03/08 12:54:35.0로 출력되길 기대했는데
        모든 결과가 2024/06/25로 출력됩니다.

        // 2016/10/20 16:15:17 (GMT+09:00) Seoul
        // console.log('getGMTFormat', dtm)
        // Asia/Seoul
        // toString() : Wed Jul 21 2010 10:13:44 GMT+0900
        // console.log('dtmFormat', dtm)
        if (_.isEmpty(format)) {
          format = 'YYYY/MM/DD HH:mm:ss'
        }
        if (_.isDate(dtm)) {
          return moment(dtm).format(format)
        } else if (_.isString(dtm)) {
          if (_.isEmpty(dtm)) {
            return
          }
          return moment(dtm, ['YYYYMMDDHHmmss', 'YYYYMMDDHHmm', 'YYYYMMDD', 'YYYY-MM-DD', 'YYYY/MM/DD']).format(format)
        }
        return moment([]).format(format)
      */

      if (moment(dtm).isValid()) { // dtm이 유효한 날짜인지 검사
        return moment(dtm).format(format || 'YYYY-MM-DD HH:mm:ss.S')
      }
      /*
       * dtmFormat 호출 방법
       *
       * const dtm = '2024-02-16 01:21:44.0'
       * console.log(dtmFormat(dtm)) // 기본 포맷인 'YYYY-MM-DD HH:mm:ss.S'로 출력됩니다.
       * console.log(dtmFormat(dtm, 'YYYY/MM/DD')) // 'YYYY/MM/DD' 포맷으로 출력됩니다.
       * console.log(dtmFormat(dtm, 'YYYY년 MM월 DD일 HH시 mm분')) // 'YYYY년 MM월 DD일 HH시 mm분' 포맷으로 출력됩니다.
       */
    },
    getComma (o) {
      let regex = /\B(?=(\d{3})+(?!\d))/g
      if (_.isNumber(o)) {
        return o.toString().replace(regex, ',')
      } else if (_.isString(o)) {
        return o.replace(regex, ',')
      }
      return o
    },
    // 일단 여기를 보자..
    getUserLangCd () {
      return localStorage.getItem('language') || 'ko'
    },
    getUserTimeZoneId () {
      return localStorage.getItem('timeZone') || 'Asia/Seoul'
    },
    getMbrNo () {
      return this.getStore('root').getters.getSessionMbrNo
    },
    getUserId () {
      return this.getStore('root').getters.getSession.userId
    },
    getEduGrpCd () {
      let promoStore = window.vue.getStore('promoInfo')
      return promoStore.state.promoInfo.eduGroupCode
    },
    getCoGrpCd () {
      let promoStore = window.vue.getStore('promoInfo')
      return promoStore.state.promoInfo.coGroupCode
    },
    // isCancel (obj1, obj2) {
    //   return _.isEqual(obj1, obj2)
    // },
    // // 영문|숫자|_.-_
    // // 특수문자 제외
    // isNotSchr (value) {
    //   return true
    // },
    // getSortColumn (cols, key, d) {
    //   // console.log('getSortColumn', cols)
    //   const col = _.findIndex(cols, { name: key })
    //   if (col < 0) return d
    //   return col
    // },
    // getPageRows (rows, key, d) {
    //   const row = _.findIndex(rows, (v) => { return v === key })
    //   if (row < 0) return d
    //   return row
    // },
    getIsIE () {
      const agent = navigator.userAgent.toLowerCase()
      return (navigator.appName === 'Netscape' && agent.indexOf('trident') !== -1) || agent.indexOf('msie') !== -1
    },
    /* 원본&현재 데이터 비교 - 변경대상 있으면 return true */
    compareData (origin, current) {
      if (origin instanceof Array && current instanceof Array) { // Array 비교
        if (origin.length !== current.length) return true
        return origin.some((originObj, idx) => {
          return Object.keys(originObj).some(key1 => {
            return Object.keys(current[idx]).some(key2 => {
              if (_.isEqual(key1, key2)) {
                // console.log('key', key1)
                // console.log('value1', originObj[key1])
                // console.log('value2', current[idx][key2])
                if ((_.isEmpty(originObj[key1]) || originObj[key1].length === 0) && (_.isEmpty(current[idx][key2]) || current[idx][key2].length === 0)) { // null, '', []은 동일 데이터로 판별
                  return false
                } else if (originObj[key1] instanceof Array && current[idx][key2] instanceof Array) { // value가 Array일 경우
                  // console.log('>>> [ array in array ]')
                  return this.compareData(originObj[key1], current[idx][key2])
                } else if (_.isEqual(typeof originObj[key1], 'object') && _.isEqual(typeof current[idx][key2], 'object') && Object.keys(originObj[key1]).length > 0 && Object.keys(current[idx][key2]).length > 0) { // value가 Object일 경우
                  // console.log('>>> [ object in object ]')
                  return this.compareData(origin[key1], current[key2])
                } else if (!_.isEqual(originObj[key1], current[idx][key2])) {
                  if (key1.endsWith('Dtm')) { // 날짜는 동일포맷으로 변경 후 비교
                    if (!_.isEqual(this.dtmFormat(originObj[key1]), this.dtmFormat(current[idx][key2]))) {
                      return true
                    } else {
                      return false
                    }
                  } else if (key1.endsWith('Yn')) { // 사용여부 : null, '', 'N'은 동일 데이터로 판별
                    // console.log('ynValue1', originObj[key1])
                    // console.log('ynValue2', current[idx][key2])
                    if ((_.isEmpty(originObj[key1]) || _.isEqual(originObj[key1], 'N')) && (_.isEmpty(current[idx][key2]) || _.isEqual(current[idx][key2], 'N'))) {
                      return false
                    } else {
                      return true
                    }
                  } else {
                    return true
                  }
                } else {
                  return false
                }
              } else {
                return false
              }
            })
          })
        })
      } else { // Object 비교
        if ((_.isEmpty(origin) && !_.isEmpty(current)) || (!_.isEmpty(origin) && _.isEmpty(current))) {
          return true
          // } else if (Object.keys(origin).length !== Object.keys(current).length) { // 현재 데이터에 특정프로세스로 인하여 추가된 데이터가 있을 수 있으므로 체크예외
          //   console.log('length1', Object.keys(origin).length)
          //   console.log('length2', Object.keys(current).length)
          //   return true
        } else if (_.isEmpty(origin) && _.isEmpty(current)) {
          return false
        }
        return Object.keys(origin).some(key1 => {
          return Object.keys(current).some(key2 => {
            if (_.isEqual(key1, key2)) {
              // console.log('key', key1)
              // console.log('value1', origin[key1])
              // console.log('value2', current[key2])
              if ((_.isEmpty(origin[key1]) || origin[key1].length === 0) && (_.isEmpty(current[key2]) || current[key2].length === 0)) { // null, '', []은 동일 데이터로 판별
                return false
              } else if (origin[key1] instanceof Array && current[key2] instanceof Array) { // value가 Array일 경우
                // console.log('>>> [ object in array ]')
                return this.compareData(origin[key1], current[key2])
              } else if (_.isEqual(typeof origin[key1], 'object') && _.isEqual(typeof current[key2], 'object') && Object.keys(origin[key1]).length > 0 && Object.keys(current[key2]).length > 0) { // value가 Object일 경우
                // console.log('>>> [ object in object ]')
                return this.compareData(origin[key1], current[key2])
              } else if (!_.isEqual(origin[key1], current[key2])) {
                if (key1.endsWith('Dtm')) { // 날짜는 동일포맷으로 변경 후 비교
                  // console.log('dtmValue1', this.dtmFormat(origin[key1]))
                  // console.log('dtmValue2', this.dtmFormat(current[key2]))
                  if (!_.isEqual(this.dtmFormat(origin[key1]), this.dtmFormat(current[key2]))) {
                    return true
                  } else {
                    return false
                  }
                } else if (key1.endsWith('Yn')) { // 사용여부 : null, '', 'N'은 동일 데이터로 판별
                  // console.log('ynValue1', origin[key1])
                  // console.log('ynValue2', current[key2])
                  if ((_.isEmpty(origin[key1]) || _.isEqual(origin[key1], 'N')) && (_.isEmpty(current[key2]) || _.isEqual(current[key2], 'N'))) {
                    return false
                  } else {
                    return true
                  }
                } else {
                  return true
                }
              } else {
                return false
              }
            } else {
              return false
            }
          })
        })
      }
    },
    // Object Clone
    deepClone (obj) {
      let clone = {}
      if (Array.isArray(obj)) clone = []
      for (let key in obj) {
        if (typeof obj[key] === 'object' && obj[key] != null) {
          clone[key] = this.deepClone(obj[key])
        } else {
          clone[key] = obj[key]
        }
      }
      return clone
    },
    // 차세대 PC 메인 페이지 이동
    getStudyHomeUrl () {
      let linkUrl = ''
      if (process.env.NODE_ENV === 'local') {
        linkUrl = 'https://www.multi-qa.com/m/#/CicStudy'
      } else if (process.env.NODE_ENV === 'development') {
        linkUrl = 'https://www.multi-dev.com/m/#/CicStudy'
      } else if (process.env.NODE_ENV === 'stage') {
        linkUrl = 'https://qanext.multicampus.com/m/#/CicStudy'
      } else {
        linkUrl = 'https://www.multicampus.com/m/#/CicStudy'
      }

      return linkUrl
    },
    // 모바일웹 메인 페이지 이동
    gotoMobileMain () {
      location.href = window.location.protocol + '//' + window.location.hostname + (isEmpty(window.location.port) ? '' : ( ':' + window.location.port))
    },
    // 페이지 이동
    goPage (name, params) {
      let pushItem = {}
      if (params) {
        pushItem = { 'name': name, 'params': params }
      } else {
        pushItem = { 'name': name }
      }
      this.$goPage(pushItem)
    },
    // 데이터 조회 메소드(동기식)
    async fetchDataSync (paramUrl, params) {
      let result = await this.$http.b2c[paramUrl](this, params)
      return result.data
    },
    // 데이터 조회 메소드(비동기식)
    fetchData (paramUrl, params, callback) {
      this.$http.b2c[paramUrl](this, params).then((result) => {
        const oriData = result.data
        if (oriData.status === 'OK') {
          // console.log(`${paramUrl}`, params, data)

          // 콜백 함수 실행
          if (callback) {
            callback(oriData.data, null, oriData)
          }
        } else {
          // 상태가 OK가 아닌 경우 (ERROR 등)
          if (callback) {
            callback(null, null, oriData)
          }
        }
      }).catch((error) => {
        // 네트워크 요청 실패 등의 경우
        if (callback) {
          callback(null, error, null) // 에러 전달
        }
      })
    },
    // 메뉴 트리 구조 변환
    makeTreeForMenu (listData) {
      if (listData === null || listData.length < 1) {
        return {
          menus: []
        }
      }
      const treeObj = {
        menus: []
      }

      forEach(orderBy(listData, ['level'], ['asc']), function (val, idx) {
        if (val.level === 1) {
          // no works!!
        } else if (val.level === 2) {
          this.$set(val, 'isActive', idx === 0)
          treeObj.menus.push(val)
        } else {
          const parentMenu = find(listData, { level: val.level - 1, siteMenuSno: val.uppMenuSno })

          if (parentMenu !== undefined) {
            if (parentMenu.menus === undefined) {
              parentMenu.menus = []
            }
            parentMenu.menus.push(val)
          }
        }
      }.bind(this))

      return treeObj
    },
    // 메뉴 링크 처리 메소드
    goMenuLink (menuItem) {
      // return window.location.protocol + '//' + menuItem.menuPathNm
      console.log('goMenuLink::menuItem', menuItem)
      // let linkUrl = menuItem.linkUrl.replace('/', '')

      if (menuItem.paramCntnt01 === 'BoardMstr') { // 게시판
        console.log('게시판 번호 : ', menuItem.paramCntnt02)
        // let pushItem = { name: menuItem.paramCntnt01 /* "BoardMstr" */, query: { bltndMstrSno: menuItem.paramCntnt02 } }
        this.$goPage({ name: menuItem.paramCntnt01 /* "BoardMstr" */, query: { bltndMstrSno: menuItem.paramCntnt02 } })
        // history.pushState(pushItem, '', '')
        // this.$router.push(pushItem).catch((e) => { console.log(e) }) // boardNm: menuItem.menuNm,
      } else if (menuItem.paramCntnt01 === 'CorsList') { // 과정목록
        console.log('go CorsList : ', menuItem.paramCntnt02, menuItem.paramCntnt03, menuItem.paramCntnt04)
        var uuid = Vue.utils.createUUID()
        this.$goPage({ name: menuItem.paramCntnt01 /* CorsList */, query: { uuid: uuid, clsfCd1: menuItem.paramCntnt02, clsfCd2: menuItem.paramCntnt03, clsfCd3: menuItem.paramCntnt04 } } )
        // let pushItem = { name: menuItem.paramCntnt01 /* CorsList */, query: { uuid: uuid, clsfCd1: menuItem.paramCntnt02, clsfCd2: menuItem.paramCntnt03, clsfCd3: menuItem.paramCntnt04 } }
        // history.pushState(pushItem, '', '')
        // this.$router.push(pushItem).catch((e) => { console.log(e) })
      } else if (!isEmpty(menuItem.paramCntnt01)) {
        let params = {}
        if (menuItem.paramCntnt02) {
          params = { paramCntnt02: menuItem.paramCntnt02 }
        }
        this.$goPage({ name: menuItem.paramCntnt01, query: params })
      } else if (!isEmpty(menuItem.linkUrl )) {
        // 메뉴에서는 default : 새창
        let tagetCd = isEmpty(menuItem.paramCntnt07) ? 'B' : menuItem.paramCntnt07
        let target = this.getTarget(tagetCd)
        console.log('menuItem.linkUrl', menuItem.linkUrl, target)

        if (menuItem.linkUrl.startsWith('/') && target === '_self') {
          this.$router.push(menuItem.linkUrl)
        } else {
          window.open(menuItem.linkUrl, target)
        }
      }
    },
    // 포틀릿(배너형) 링크 처리 메소드
    goPotltLink (prtltItem) {
      /** genLinkScCd [GEN_LINK_SC_CD]
       * B	_blank
       * P	_parent
       * S	_self
       * T	_top
       */

      let target = this.getTarget(prtltItem.genLinkScCd)
      let { bannUrl } = prtltItem

      if (bannUrl.startsWith('/') && target === '_self') {
        if (bannUrl.includes('clsfCd')) { // 과정코드가 있을경우
          const newUuid = this.$utils.createUUID()
          bannUrl = this.updateUrlWithNewUuid(bannUrl, newUuid)
        }
        this.$router.push(bannUrl)
      } else {
        window.open(bannUrl, target)
      }
    },
    // URL에서 uuid 파라미터를 새 uuid로 교체하거나 추가하는 헬퍼 함수
    updateUrlWithNewUuid (url, newUuid) {
      const urlObj = new URL(url, window.location.origin)
      if (urlObj.searchParams.has('uuid')) {
        urlObj.searchParams.set('uuid', newUuid)
      } else {
        urlObj.searchParams.append('uuid', newUuid)
      }
      return urlObj.pathname + urlObj.search
    },
    // 윈도우 오픈시 타켓코드 조회
    getTarget (targetCd) {
      /** genLinkScCd [GEN_LINK_SC_CD]
       * B	_blank
       * P	_parent
       * S	_self
       * T	_top
       */
      let target = '_self'
      switch (targetCd) {
        case 'B' : target = '_blank'
          break
        case 'P' : target = '_parent'
          break
        case 'S' : target = '_self'
          break
        case 'T' : target = '_top'
          break
        default : target = '_self'
      }
      return target
    },
    // 학습홈 이동
    goOpenStudy (corsYr, corsCd, corsDgrCd, eduDgrCd) {
      console.log('corsYr', corsYr)
      console.log('corsCd', corsCd)
      console.log('corsDgrCd', corsDgrCd)
      console.log('eduDgrCd', eduDgrCd)
      let pParam = {
        corsYr: corsYr,
        corsCd: corsCd,
        corsDgrCd: corsDgrCd,
        eduDgrCd: eduDgrCd
      }
      let isMobile = !window.vue.getStore('homeInfo').state.isDeskTopMode
      if (isMobile) { // 모바일 학습창
        // window.vue.getStore('homeInfo').state.deviceType // 모바일, 태블릿, PC 구분

        // let linkUrl = 'https://www.multi-qa.com/m/#/CicStudy'
        let linkUrl = this.getStudyHomeUrl() // 'http://26.2.105.29:8010/#/CicStudy'

        // '/CicStudy/:langCd?/:tenantId?/:orgId?/:mbrNo?/:corsCd?/:corsYr?/:corsDgrCd?/:gbn?'
        let langCd = this.getUserLangCd()
        let tenantId = window.vue.getStore('promoInfo').state.promoInfo.eduGroupCode
        let orgId = 'orgId'
        let mbrNo = 'USER020' + window.vue.getStore('root').getters.getSessionMbrNo

        let params = '/' + langCd + '/' + tenantId + '/' + orgId + '/' + mbrNo + '/' + corsCd + '/' + corsYr + '/' + corsDgrCd // + '/' + gbn

        console.log('linkUrl + params', linkUrl + params)
        window.open(linkUrl + params, 'nrw_lrnhm')
      } else { // PC 학습창
        this.fetchData('getStudyToken', pParam, (data) => {
          console.log('❄️ ~ this.getStudyToken.fetchData ~ data.:', data )
          let url = data.url
          // if (process.env.NODE_ENV === 'local' || process.env.NODE_ENV === 'stg') {
          //   url = 'https://learning.multi-qa.com/lrn/common/lrnSsoProc'
          // } else {
          //   url = 'https://learning.multicampus.com/lrn/common/lrnSsoProc'
          // }
          url += '?' + '_csrf=' + data.token + '&lrnTypeCd=H&lrnMode=sem&codeType=C&corsCd=' + pParam.corsCd + '&corsYr=' + pParam.corsYr + '&corsDgrCd=' + pParam.corsDgrCd + '&eduDgrCd=' + pParam.eduDgrCd + '&authToken=' + data.authToken + '&eduGrpCd=' + data.eduGrpCd
          console.log('❄️ ~ url ~ :', url)
          window.open(url, 'nrw_lrnhm')
        })
      }
    },

    // 과정 상세 이동
    goOpenCorsDetail (corsCd) {
      console.log('과정 상세 이동 ', corsCd)

      this.goPage({name: 'CrsDetail', query: { corsCd: corsCd }})
    },
    // 맛보기 팝업
    goPrewUrl (corsCd, corsPrevwUrl) {
      let prevwUrl = corsPrevwUrl
      if (prevwUrl !== null || prevwUrl !== '') {
        prevwUrl = 'https://learning.multicampus.com/lrn/common/commCrsPreview?lrnTypeCd=P&code=' + corsCd
      }

      var windowOptions = {
        width: 1000,
        height: 800,
        scrollbars: 'no'
      }
      this.$utils.common.openWindowPopup(prevwUrl, {}, undefined, windowOptions, true)
    },
    // 사이드명 조회
    getSiteNm () {
      return window.vue.getStore('homeInfo').state.mobileInfo.intrSiteNm
    }
  }

}
export default globalMixin



// WEBPACK FOOTER //
// ./src/mixin/globalMixin.js